<header class="header flex-spaceBetween-center profile">
    <img [ngSrc]="'assets/img/logo.png'" alt="ingredion_logo" width="130" height="30" />
    <div class="flex-center">
        <h1>Texicon</h1>
    </div>
    <div class="profile" [matMenuTriggerFor]="logoutMenu">
        <span class="username">{{ userProfile?.name }}
            @if (activeUserRoles()) {
            <span class="user-role">({{ activeUserRoles().replaceAll(",", ", ") || "" }})</span>
            }</span>
        <mat-icon class="profile-icon">account_circle</mat-icon>
        <mat-menu #logoutMenu="matMenu" xPosition="before" yPosition="below">
            <button mat-menu-item (click)="logoutUser()">
                <span class="account-menu"> <mat-icon class="material-symbols-outlined icon">logout</mat-icon>
                    {{ 'logout' | translate }}</span>
            </button>
        </mat-menu>
    </div>
</header>